/*
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import type { ExpirableLRUOptions } from '../types/ExpirableLRUOptions'
import type { StoredData } from '../types/StoredData'
import { isValidStoredData } from './isValidStoredData'

export function getExpiresInMs(
  data: StoredData,
  options: Pick<ExpirableLRUOptions<unknown, unknown>, 'ttl' | 'version'>
) {
  if (isValidStoredData(data, options)) {
    const [, , storedTTL, storedAt] = data
    const ttl = storedTTL ?? options.ttl ?? Infinity
    if (ttl !== Infinity) {
      const expiresAt = storedAt + ttl
      return expiresAt - Date.now()
    }
  }
  return null
}
